/**
 * Function to control the dropdown with checkboxes
 * 
 * @param {string} toggleButton css class for dropdown button
 * @param {string} dropContainer css class for dropdown container
 * @param {string} toggleContainer css class for dropdown toggle container
 * @param {string} arrowEle css class for dropdown arrow
 * 
 * @returns void
 */
export const toggleDropDown = (toggleButton: string, dropContainer: string, toggleContainer: string, arrowEle?: string) => {
  const toggle = document.querySelector(toggleButton) as HTMLElement;
  const toggleCont = document.querySelector(toggleContainer) as HTMLElement;
  const arrow = document.querySelector(arrowEle!) as HTMLElement;
  const d = document.getElementById(dropContainer) as HTMLElement;

  if(!toggle) return;

  toggle.addEventListener('click', () => {
    const rect = toggle.getBoundingClientRect();
    const height = screen.height;
    const pos = height / 2;

    arrow.classList.toggle('active');    

    d.classList.toggle( rect.top > pos ? "afa_show-bottom" : "afa_show-top" );    

    //toggle.removeEventListener('click', arguments.callee);
  });

  document.addEventListener('click', event => {
    // @ts-ignore    
    if(toggleCont !== event.target && !toggleCont.contains(event.target)) {
      d.classList.contains('afa_show-bottom') && d.classList.remove("afa_show-bottom") || d.classList.remove("afa_show-top");    
      arrow.classList.contains('active') && arrow.classList.toggle('active');      
    }
  });
}

/**
 * Handles dropdowns.  Creates the selection list, search list input, and displays the selected item from list.
 * 
 * @param {object} data object { id: string, name: string }
 * @param {string} elementNumber unique number for element html tags
 * @param {string} dropText  custom text for dropdown search not found
 * @param {boolean} [search] optional: include the search bar with dropdown
 * @param {boolean} [displayResult] optional: display the selected results in bar
 * @param {boolean} [hasAccess] optional: flag for dropdown access
 */
export const dropdown = (data: Array<any>, elementNumber: string, dropText: string, search?: boolean, displayResult?: boolean, hasAccess?: boolean) => {
  const partnerDrop = document.querySelector(`#aafp_dropdown-container-${elementNumber}`) as HTMLElement;
  const dropdownbutton = document.querySelector(`#aafp_dropdown-button-${elementNumber}`) as HTMLElement;
  const dropdownContainer = document.querySelector(`.aafp_dropdown-container-${elementNumber}`) as HTMLElement;
  const arrow = document.querySelector(`.arrow-${elementNumber}`) as HTMLElement;  

  if (!partnerDrop) return;

  /**
   * Handles the position of the dropdown window depending on where the dropdown is located.
   * 
   * @param {any} event
   */
  const dropWindowPosition = (event: any) => {
    const rect = dropdownContainer.getBoundingClientRect();
    const height = screen.height;
    const pos = height / 2;

    arrow.classList.toggle('active');
    
    partnerDrop.classList.toggle( rect.top > pos ? "afa_show-bottom" : "afa_show-top" );
  }

  /**
   * Controls the dropdown visibility when a click is detected outside of the dropdown container.
   * 
   * @param {any} event
   */
  function handleDropdownClose(event: any) {  
    if(dropdownContainer !== event.target && !dropdownContainer.contains(event.target)) { 
      partnerDrop.classList.contains('afa_show-bottom') && partnerDrop.classList.remove("afa_show-bottom") || partnerDrop.classList.remove("afa_show-top");    
      arrow.classList.contains('active') && arrow.classList.toggle('active'); 
    }    
  }

  /**
   * Displays the selected item from the dropdown list
   * 
   * @param {any} event
   * @param {string} dataSet the index of the selected item
   * @param {string} textContent the text of the item
   */
  function displaySelectedItem(event: any, dataSet: string, textContent: string) {
    handleDropdownClose(event); 
  
    if(dropdownContainer.classList.contains('drop-error')) {
      let errorMsg = document.querySelector('.dropdown-error-' + elementNumber) as HTMLElement;
      errorMsg.innerText = '';
      dropdownContainer.classList.remove('drop-error');
      dropdownContainer.classList.add('drop-valid');
    }

    if(displayResult) {
      dropdownbutton.innerHTML = `${textContent}`;
      dropdownbutton.dataset.value = `${dataSet}`;
    }
    
    if(input) input.value = '';
    let a = partnerDrop.getElementsByTagName("a");
    for ( let i = 0; i < a.length; i++) {
      a[i].style.display = "";
    }
  }

  if(partnerDrop.hasChildNodes()) {
    while ( partnerDrop.firstChild ) {
      partnerDrop.removeChild(partnerDrop.firstChild);      
    }

    createElements(data, elementNumber, partnerDrop, dropText, search);
  } else {
    createElements(data, elementNumber, partnerDrop, dropText, search);
    if ( data.length === 1 ) {
      displaySelectedValue('.aafp_list-partner', 'partner', `${data[0].id}`);
    }

    if ( hasAccess ) {      
      dropdownContainer.addEventListener('click', event => {
        const searchInput = document.querySelector(`#aafp_dropdown-input-${elementNumber}`) as HTMLElement;
        if ( event.target === searchInput ) return;
        dropWindowPosition(event) 
      });
      document.addEventListener('click', event => {
        handleDropdownClose(event) 
      }); 
    } else {
      dropdownContainer.classList.add('aafp_drop-disabled');
    }
  }

  const input = document.querySelector(`#aafp_dropdown-input-${elementNumber}`) as HTMLInputElement;

  /**
   * Function to filter the dropdown list
   */
  function filterDropdownList() {
    const filter = input.value.toUpperCase();
    const aElements = partnerDrop.getElementsByTagName("a");

    for (const a of aElements) {
      const txtValue = a.textContent;
      if (txtValue && txtValue.toUpperCase().indexOf(filter) > -1) {
        a.style.display = "";
      } else {
        a.style.display = "none";
      }
    }
  }

  if(input) {    
    let timeout: any;
    input.addEventListener('keyup', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => filterDropdownList(), 300);
    });
  }

  // Use event delegation to handle clicks on individual items
  partnerDrop.addEventListener('click', event => {
    const target = event.target as HTMLElement;
    if (target.tagName === 'A') {
      displaySelectedItem(event, target.dataset.content!, target.textContent!);
    }
  });
}

/**
 * Populates the list for the dropdown
 * 
 * @param {object} data 
 * @param {string} elementNumber 
 * @param {HTMLElement} partnerDrop
 * @param {string} dropText
 * @param {boolean} search An optional param (flag for the search input)
 */
const createElements = (data: object, elementNumber: string, partnerDrop: HTMLElement, dropText: string, search?: boolean) => {
  if ( search ) {
    const searchInput = document.createElement('input');
    searchInput.type = 'text';
    searchInput.placeholder = 'Search...';
    searchInput.id = `aafp_dropdown-input-${elementNumber}`;
    searchInput.className = 'aafp_input aafp_color-theme-input table-filter-clear';
    searchInput.name = '';
    partnerDrop.appendChild(searchInput); 
  }  

  if (Object.keys(data).length === 0) {
    partnerDrop.innerHTML = `<p>No ${dropText}(s) found</p>`;
    return;
  }

  Object.values(data).map((e, i) => {
    const atag = document.createElement('a');
    atag.dataset.key = `${i}`;
    atag.dataset.content = e.id;
    atag.className = `aafp_list-${elementNumber}`;
    atag.textContent = e.name;
    partnerDrop.appendChild(atag);
  }); 
}

/**
 * Selects and displays value from inputted value
 * 
 * @param {string} filterElemsClass css class for dropdown options
 * @param {string} containerNumber dropdown button css id * 
 * @param {string} selectedValue incoming value to be selected
 * @param {string} [input] search input id tag
 * 
 * @returns void
 */
export const displaySelectedValue = (filterElemsClass: string, containerNumber: string, selectedValue: string, input?: string) => {
  const elems = Array.from(document.querySelectorAll<HTMLElement>(filterElemsClass));
  const dropButton = document.querySelector(`#aafp_dropdown-button-${containerNumber}`) as HTMLElement;
  const selectedElem = elems.find((ele) => ele.dataset.content === selectedValue);

  if ( selectedElem ) {
    dropButton.innerHTML = selectedElem.textContent!;
    dropButton.dataset.value = selectedElem.dataset.content;

    if ( input ) {
      const dropdownInput = document.querySelector(input) as HTMLInputElement;
      dropdownInput.value = selectedElem.textContent!;
    }
  }
}